import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  accountId,
  focusAfterTimeout,
  currentUserIsSalesLeader,
  currentUserIsAdmin,
  callIfFunction,
} from '../../util';

import {
  getSevenImperative,
  getSevenImperatives,
  getImperativesStages,
} from '../../util/data';

import { getIcon } from '../../util/icons';

import {
  NumericalInput,
  DealSourceLink,
  UserSelect,
} from '../shared';

import Select from 'react-select';

import moment from 'moment';

import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

import {
  createOrUpdateDeal,
  deleteDeal,
} from '../../actions/deals';

import {
  IntegrationSelector
} from '../../selectors';

const DEFAULT_DEAL_STAGES = [{
  label: 'Open',
  value: 'open',
  status: 'open',
},{
  label: 'Won',
  value: 'won',
  status: 'won',
},{
  label: 'Lost',
  value: 'lost',
  status: 'lost',
}];

const DEFAULT_DEAL = {
  name: '',
  estimatedValue: '',
  estimatedCloseDate: moment().valueOf(),
  product: '',
  status: 'open',
  stage: 'open',
}

class UpdateDealModal extends Component{

  state = {
    deal: DEFAULT_DEAL,
    isCreatingNewDeal: false,
    saving: false,
    error: null,
    verifyingChecklist: false,
    confirmingDelete: false,
  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.visible && !prevProps.visible){
      focusAfterTimeout(this, 'dealNameInput');
    }
    if(this.props.editingDeal && !prevProps.editingDeal){

      let setInitialDealStage = false;
      if(!this.props.editingDeal._id && _.size((this.props.organization || {}).dealStages || []) > 0){
        setInitialDealStage = this.props.organization.dealStages[0].value
      }

      this.setState({
        deal: {
          ...this.props.editingDeal,
          ...(setInitialDealStage && { stage: setInitialDealStage, status: 'open' })
        },
        isCreatingNewDeal: !this.props.editingDeal._id,
        verifyingChecklist: this.props.skipToVerify || false,
        confirmingDelete: false,
      });
    }
  }

  updateDealProps(props){
    this.setState({
      deal: {
        ...this.state.deal,
        ...props
      }
    });
  }

  updateDealProp(propName, propValue){
    this.setState({
      deal: {
        ...this.state.deal,
        [propName]: propValue
      }
    });
  }

  clearError(){
    this.setState({
      error: null,
    });
  }

  createOrUpdateDeal(){

    if((this.state.deal.status === 'won' || this.state.deal.status === 'lost') && this.state.deal._id && !this.state.verifyingChecklist){
      //verify checklist first since this deal is marked as "won"
      this.setState({
        verifyingChecklist: true
      });

      return;
    }

    if(this.state.saving){
      return;
    }

    this.setState({
      saving: true
    });

    this.props.createOrUpdateDeal({
      ...this.state.deal,
      closeStatusProgressVerified: this.state.deal.status !== 'open',
    }, this.onUpdateSuccess.bind(this));
  }

  deleteDeal(){
    this.props.deleteDeal(this.state.deal, this.props.onDelete);
  }

  onUpdateSuccess(deal){

    //prevent duplicate callbacks
    if(!this.state.saving){
      return;
    }
    this.setState({
      saving: false
    }, () => {
      if(this.state.isCreatingNewDeal){
        this.props.onCreate(deal);
      }
      else{
        //if updated existing deal
        this.props.onUpdate(deal);
      }

      //if reassigned to different user, because we might need to change how we're viewing this deal
      if(this.state.deal.userId !== this.props.editingDeal.userId){
        callIfFunction(this.props.onReassign, deal);
      }
    });
  }

  renderFormMessage(){
    if(this.state.error){
      return <div className="form-message error">{this.state.error}</div>;
    }
    else{
      return null;
    }
  }

  formIsDirty(){

    // console.log('updating deal: ', this.props.editingDeal);

    const {
      _id,
      name,
      product,
      estimatedValue,
      estimatedCloseDate,
      status,
      stage,
      nextStep,
      sf,
      userId,
    } = this.props.editingDeal;

    if( !_id ||
      name !== this.state.deal.name ||
      estimatedValue !== this.state.deal.estimatedValue ||
      estimatedCloseDate !== this.state.deal.estimatedCloseDate ||
      product !== this.state.deal.product ||
      stage !== this.state.deal.stage ||
      status !== this.state.deal.status ||
      nextStep !== this.state.deal.nextStep ||
      userId !== this.state.deal.userId ||
      (sf && sf.accountId && sf.accountId !== this.state.deal.sf.accountId)
     ){
       return true;
     }
    else{
      return false;
    }
  }

  getSaveButtonText(){
    const { deal, saving, verifyingChecklist } = this.state;

    if(deal._id){
      if(saving){
        return "Updating...";
      }
      else{
        if(verifyingChecklist){
          return "Verify Progress";
        }
        else{
          return "Update Deal";
        }
      }
    }
    else{
      if(saving){
        return "Adding...";
      }
      else{
        return "Add Deal";
      }
    }

  }

  getOptionForValue(options, value){
    return _.find(options, option => {
      return option.value === value;
    });
  }

  getImperativeStatus(id){
    //let hasFailedTask = false;
    let allTasksComplete = true;

    // console.log('checking imperative status: ', id);

    _.each(getSevenImperative(id).tasks, task => {
      const taskStatus = this.getImperativeTaskStatus(task.id);
      // console.log(`subtask [${task.id}]: ${taskStatus}`);
      if(taskStatus !== 'complete'){
        //hasFailedTask = true;
        allTasksComplete = false;
      }
    });

    return allTasksComplete ? 'complete' : 'incomplete';
  }
  getImperativeTaskStatus(id){
    const item = (this.state.deal.imperativeTasks || {})[id];

    if(item === 'complete'){
      return 'complete';
    }
    else if(item === 'failed'){
      return 'failed';
    }
    else{
      return 'incomplete';
    }
  }

  getFunnelTaskStatus(funnelTask){

    if(funnelTask.imperativeId){
      //check if imperative is complete
      return this.getImperativeStatus(funnelTask.imperativeId);
    }
    else if(funnelTask.imperativeTaskId){
      //check if imperative item is complte
      return this.getImperativeTaskStatus(funnelTask.imperativeTaskId)
    }
    else{
      const item = (this.state.deal.funnelTasks || {})[funnelTask.id];

      if(item === 'complete'){
        return 'complete';
      }
      else if(item === 'failed'){
        return 'failed';
      }
      else{
        return 'incomplete';
      }
    }
  }

  renderImperativeTask(imperativeTask){
    const { id, text, imperative } = imperativeTask;

    const itemStatus = this.getImperativeTaskStatus(id);

    const isComplete = itemStatus === 'complete';
    const isFail = itemStatus === 'failed';
    const isIncomplete = itemStatus === 'incomplete';

    return (
      <li
        key={id}
        className={`imperative-item ${itemStatus}`}
      >
        <div className="imperative-item-text">{text}</div>
        <div className="imperative-item-check">{isComplete ? getIcon('check-fill') : (isFail ? getIcon('check-fail') : getIcon('check-empty'))}</div>
      </li>
    );
  }

  renderImperative(imperative){

    const { id, name, tasks } = imperative;

    return(
      <li key={id} className="imperative">
        <h6>{name}</h6>
        <ul>{_.map(tasks, this.renderImperativeTask.bind(this))}</ul>
      </li>
    )
  }

  renderFunnelTask(funnelTask){

    const { id, stage, imerativeItem, imperative, text} = funnelTask;

    const itemStatus = this.getFunnelTaskStatus(funnelTask);

    const isComplete = itemStatus === 'complete';
    const isFail = itemStatus === 'failed';
    const isIncomplete = itemStatus === 'incomplete';

    return(
      <div
        key={id}
        className={`stage-item stage-item-${id} ${itemStatus}`}
      >
      <div
        className="stage-item-check">{isComplete ? getIcon('check-fill') : (isFail ? getIcon('check-fail') : getIcon('check-empty'))}</div>
        <div className="stage-item-text">{text}</div>
      </div>
    )
  }

  renderDealChecklistReview(){

    const imperatives = getSevenImperatives();
    const stages = getImperativesStages();

    return(
      <div className="verify-checklist">
        <h2>Verify Deal Progress</h2>
        <p>Make sure the progress on this deal is logged correctly, as this ensures that proper metrics are being captured for your organization about which tasks result in won/lost deals.</p>
        <h3>Seven Imperative Progress</h3>
        <ul>
          {_.map(imperatives, this.renderImperative.bind(this))}
        </ul>
        <div className="objectives">
          <h3>Seller Objectives</h3>
          <ul>{_.map(stages.objectives, this.renderFunnelTask.bind(this))}</ul>
        </div>
        <div className="reciprocations">
          <h3>Buyer Reciprocations</h3>
          <ul>{_.map(stages.reciprocations, this.renderFunnelTask.bind(this))}</ul>
        </div>
      </div>
    )
  }

  formIsValid(){
    const {
      _id,
      name,
      product,
      estimatedValue,
      estimatedCloseDate,
      status,
    } = this.state.deal;

    return  name &&
            name !== '' &&
            estimatedValue &&
            estimatedValue !== '' &&
            estimatedCloseDate &&
            estimatedCloseDate !== '';
  }

  renderDealStageSelect(){
    const {
      stage,
      status
    } = this.state.deal;

    const stageOptions = this.props.organization && this.props.organization.dealStages || DEFAULT_DEAL_STAGES;

    return (
      <Select
        classNamePrefix={'react-select'}
        className='react-select-container deal-status'
        value={this.getOptionForValue(stageOptions, stage)}
        options={stageOptions}
        onChange={(option) => { this.updateDealProps({ stage: option.value, status: option.status}); } }
        isSearchable={true}
        isDisabled={!this.userCanUpdateStage()}
      />
    )
  }

  userCanUpdateNextStep(){
    if(this.props.integration === 'salesforce'){
      return (this.props.organization || {}).integrationNextStepEditingEnabled;
    }
    else{
      //TODO support non-SF next step
      return false;
    }
  }
  userCanUpdateName(){
    if(this.props.integration === 'salesforce'){
      return !!(this.props.organization || {}).integrationDealNameEditingEnabled;
    }
    else{
      return true;
    }
  }
  userCanUpdateStage(){
    if(this.props.integration === 'salesforce'){
      return !!(this.props.organization || {}).integrationStageUpdatingEnabled;
    }
    else{
      return true;
    }
  }

  updateAssignedSeller(newSellerId){
    alert("should udpat assigend seller!");
  }

  renderDealForm(){

    const {
      _id,
      name,
      product,
      products,
      estimatedValue,
      estimatedCloseDate,
      status,
      nextStep,
      source,
      userId,
    } = this.state.deal;

    const { viewingUser } = this.props;

    const estimatedCloseDateMoment = moment(estimatedCloseDate);

    const isNewDeal = _id ? false : true;

    const dealWon = status === 'won';

    return(
      <form className="velocity-form">
        <h2>{isNewDeal ? 'Add' : 'Update'} deal</h2>
        {viewingUser && accountId() !== viewingUser.uid &&
          <p className="subheading">{getIcon('info-bold')} Adding deal on behalf of {viewingUser.firstName} {viewingUser.lastName}</p>
        }
        {this.renderFormMessage()}
        {source === 'salesforce' &&
          <p className="deal-source-link"><DealSourceLink deal={this.state.deal} label="Edit in Salesforce" /></p>
        }
        <div className="form-group">
          <div className="input-group">
            <label htmlFor="deal-name">{dealWon ? 'Deal Name' : 'Deal Name'}</label>
            <input
              ref={input => { this.dealNameInput = input; }}
              id="deal-name"
              className="fs-block"
              autoComplete="off"
              type="text"
              value={name || ''}
              disabled={!this.userCanUpdateName()}
              onChange={e => { this.updateDealProp('name', e.target.value); }}
              />
          </div>
        </div>
        <div className="form-group">
          <div className="input-group full-width">
            <label htmlFor="deal-name">Deal stage</label>
            {this.renderDealStageSelect()}
          </div>
        </div>
        <div className="form-group">
          <div className="input-group third-width">
            {!this.props.integration &&
              <React.Fragment>
                <label htmlFor="deal-product">Product or Service</label>
                <input
                  id="deal-product"
                  autoComplete="off"
                  type="text"
                  className="fs-block"
                  value={product || ''}
                  onChange={e => { this.updateDealProp('product', e.target.value); }}
                  />
              </React.Fragment>
            }
            {this.props.integration &&
              <React.Fragment>
                <label htmlFor="deal-product">Products</label>
                <input
                  id="deal-product"
                  autoComplete="off"
                  type="text"
                  className="fs-block disabled"
                  value={_.map(products, 'name').join(', ')}
                  readOnly={true}
                  />
              </React.Fragment>
            }
          </div>
          <div className="input-group third-width">
            <label htmlFor="deal-value">{dealWon ? 'Deal Value' : 'Estimated value'}</label>
            <NumericalInput
              id="deal-value"
              className={`fs-block ${products && products.length > 0 ? 'disabled' : ''}`}
              formatThousands={true}
              value={estimatedValue || ''}
              onUpdate={val => { this.updateDealProp('estimatedValue', val); }}
              disabled={products && products.length > 0}
            />
          </div>
          <div className="input-group fs-block third-width">
            <label htmlFor="deal-close">{dealWon ? 'Closed on' : 'Estimated close date'}</label>
            <SingleDatePicker
              hideKeyboardShortcutsPanel={true}
              date={estimatedCloseDateMoment}
              onDateChange={date => { this.updateDealProp('estimatedCloseDate', date ? date.valueOf() : null); }}
              id="update-deal-estimated-close-date"
              focused={this.state.estimatedClosedDatePickerFocused}
              onFocusChange={({focused}) => { this.setState({ estimatedClosedDatePickerFocused: focused }); }}
              />
          </div>
          {(currentUserIsSalesLeader() || currentUserIsAdmin()) &&
            <div className="input-group full-width" style={{marginBottom: 20}}>
              <label htmlFor="deal-next-step">Assigned Seller</label>
              <UserSelect
                disabled={source}
                selectUser={(newUserId) => { this.updateDealProp('userId', newUserId); }}
                users={this.props.users}
                selectedUser={userId}
                />
            </div>
          }
          {this.userCanUpdateNextStep() &&
            <div className="input-group full-width">
              <label htmlFor="deal-next-step">Next Step</label>
              <input
                id="deal-next-step"
                className="fs-block"
                type="text"
                value={nextStep}
                onChange={e => { this.updateDealProp('nextStep', e.target.value); }}
              />
            </div>
          }
        </div>
      </form>
    )
  }

  renderActions(){
    const {
      saving,
      verifyingChecklist
    } = this.state;

    const {
      source
    } = this.state.deal;

    const formIsValid = this.formIsValid();

    if(source === 'salesforce'){
      return (
        <template>
          <button className="button salesforce-button" onClick={this.createOrUpdateDeal.bind(this)} disabled={saving || !formIsValid}>{getIcon('salesforce-outline')}{saving ? 'Syncing...' : (verifyingChecklist ? 'Verify Progress' : 'Sync Changes')}</button>
          <button className="button grey-button" onClick={this.props.hide}>{verifyingChecklist ? 'Edit...' : 'Cancel'}</button>
        </template>
      )
    }
    else{
      return (
        <template>
          <button className="button primary" onClick={this.createOrUpdateDeal.bind(this)} disabled={saving || !formIsValid}>{this.getSaveButtonText()}</button>
          <button className="button grey-button" onClick={this.props.hide}>{verifyingChecklist ? 'Edit...' : 'Cancel'}</button>
        </template>
      )
    }
  }

  render(){

    if(!this.props.visible){
      return null;
    }

    const {
      saving,
      verifyingChecklist,
      confirmingDelete,
    } = this.state;

    const formIsValid = this.formIsValid();

    return (
      <div className={`modal update-deal ${verifyingChecklist ? 'verifying-checklist' : ''}`}>
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.hide}>X</div>
          <div className="modal-content">
            {verifyingChecklist && this.renderDealChecklistReview()}
            {!verifyingChecklist && this.renderDealForm()}
          </div>
          <div className="modal-actions">
            {!this.formIsDirty() && !saving && confirmingDelete &&
              <button className="button danger-button" onClick={this.deleteDeal.bind(this)}>Delete deal forever</button>
            }
            {!this.formIsDirty() && !saving && confirmingDelete &&
              <button className="button grey-button" onClick={() => { this.setState({ confirmingDelete: false })  } }>Nevermind</button>
            }
            {!this.formIsDirty() && !saving && !confirmingDelete && !verifyingChecklist &&
              <button className="button primary" onClick={this.props.hide}>Done</button>
            }
            {!confirmingDelete && (this.formIsDirty() || saving || verifyingChecklist) && this.renderActions()}
            {currentUserIsAdmin() && !this.formIsDirty() && !saving && !confirmingDelete &&
              <button className="button transparent-button sm secondary" onClick={() => { this.setState({ confirmingDelete: true }) }}>Delete deal</button>
            }
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    organization: state.organization.data,
    accounts: state.accounts.data,
    integration: IntegrationSelector(state),
    users: state.employees.data,
  }
}

export default connect(mapStateToProps, { createOrUpdateDeal, deleteDeal })(UpdateDealModal);



// WEBPACK FOOTER //
// ./src/components/modals/updateDeal.js